import type {
    GridCallbackDetails,
    GridColDef,
    GridPaginationModel,
    GridRowId,
    GridSortModel,
    GridValidRowModel,
} from '@mui/x-data-grid-pro';
import type { FunctionComponent } from 'react';

import type { GlobalSearchSkill } from '../../../../data-contract/global-search';
import { TableLoadingSpinner } from '../../../../design/components/LoadingSpinner';
import { pageSizeOptions } from '../common/constants';
import { GeneralDataGrid } from '../common/GeneralDataGrid';

export type HeadlineRow = {
    readonly area: 'exact' | 'related';
    readonly title: string;
    readonly type: 'headline';
};

export type SkillRow = {
    readonly area: 'exact' | 'related';
    readonly skill: GlobalSearchSkill;
    readonly type: 'skill';
};

export type TableRow = HeadlineRow | SkillRow;

type SkillsDataGridProps = {
    readonly columns: GridColDef<GridValidRowModel>[] | GridColDef<TableRow>[];
    readonly isFetching: boolean;
    readonly isPending: boolean;
    readonly noDataMessage: string;
    readonly onPaginationModelChange: (model: GridPaginationModel, details: GridCallbackDetails) => void;
    readonly onSortModelChange: (model: GridSortModel, details: GridCallbackDetails) => void;
    readonly paginationModel: GridPaginationModel;
    readonly rowCount: number;
    readonly rows: readonly TableRow[];
    readonly sortModel: GridSortModel;
};

export const SkillsDataGrid: FunctionComponent<SkillsDataGridProps> = ({
    columns,
    isFetching,
    isPending,
    noDataMessage,
    onPaginationModelChange,
    onSortModelChange,
    paginationModel,
    rowCount,
    rows,
    sortModel,
}) => (
    <div style={{ height: '70vh', width: '100%' }}>
        <GeneralDataGrid
            columns={columns}
            disableMultipleColumnsSorting={true}
            disableRowSelectionOnClick={true}
            getRowId={(row: TableRow): GridRowId => (row.type === 'headline' ? row.title : row.skill.title)}
            loading={isPending || isFetching}
            localeText={{ noRowsLabel: noDataMessage }}
            pageSizeOptions={pageSizeOptions}
            pagination={true}
            paginationMode="server"
            paginationModel={paginationModel}
            rowCount={rowCount}
            rows={rows}
            slots={{
                loadingOverlay: TableLoadingSpinner,
            }}
            sortModel={sortModel}
            sx={{ border: 'none' }}
            onPaginationModelChange={onPaginationModelChange}
            onSortModelChange={onSortModelChange}
        />
    </div>
);
